/**
 * Zweck: Beschreibt class Tutorialstep und ihren Daten- oder Funktionsvertrag.
 */
/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/tutorialstep.ts.
 */
export class Tutorialstep {
  focus_on: string;
  text: string;
  icon: string;
  roles: string[];

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(focus_on, text, icon = null, roles = []) {
    this.focus_on = focus_on;
    this.text = text;
    this.icon = icon;
    this.roles = roles;
  }
}
